import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import Layout from './DashboardLayout';
import BillingModal from '../components/settings/BillingModals';
import {
  ProjectCard,
  RecentActivityCard,
  UpcomingTasksCard,
  TaskChart,
  Calendar,
  Chat,
} from '../components/dashboard';
import { fetchCardStatus } from '../actions/user';
import { fetchRecentActivity } from '../actions/activity';
import { fetchOnlineMembers } from '../actions/team';
import { fetchTasks } from '../actions/dashboard';
import Loading from '../components/Loader';
import { STATUS_CHECK_DELAY, SETTINGS_BILLING } from '../constants';

class Dashboard extends Component {
  pageHeading = {
    preTitle: 'Overview',
    title: 'Dashboard',
  };

  componentDidMount() {
    const { getRecentActivity, getAllTasks, getOnlineMembers, getCardStatus } =
      this.props;
    getRecentActivity();
    getAllTasks();
    // Fetch online members list onMount
    getOnlineMembers();
    // Check for online members every 2 minutes
    this.statusTimer = setInterval(
      () => getOnlineMembers(),
      STATUS_CHECK_DELAY
    );
    getCardStatus();
    // Commented the Intercom code for now
    /* window.Intercom('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'cda12b15ea6074c6a096789485ff1489bc165c49',
      email: userEmail,
      name: userFirstName,
      user_id: userEmail,
    }); */
  }

  componentWillUnmount() {
    // Clear interval on un mount
    clearInterval(this.statusTimer);
  }

  render() {
    const { recentActivity, dashboardData, billingData, userData } = this.props;

    const taskSummary = [
      {
        status: 'complete',
        tasks: dashboardData.tasks.filter((item) => item.status === 'complete')
          .length,
      },
      {
        status: 'no due date',
        tasks: dashboardData.tasks.filter(
          (item) => item.status === 'no due date'
        ).length,
      },
      {
        status: 'over due',
        tasks: dashboardData.tasks.filter((item) => item.status === 'over due')
          .length,
      },
      {
        status: 'upcoming',
        tasks: dashboardData.tasks.filter((item) => item.status === 'upcoming')
          .length,
      },
    ];

    return (
      <Layout pageHeading={this.pageHeading}>
        {billingData.accountStatus !== 'cancel' &&
          userData.cardExpired === 1 && (
            <BillingModal
              modalProps={{
                showClose: true,
                actionVariant: 'primary',
                secondaryActionText: '',
                title: 'Card Expired',
                actionText: 'Update my credit card',
                content: SETTINGS_BILLING.CARD_EXPIRED,
                type: 'expired',
              }}
            />
          )}
        <section className="main-dashboard">
          <Row>
            <Col xl={8}>
              <ProjectCard isPageLoading={dashboardData.isLoading} />
              {dashboardData.tasks && dashboardData.tasks.length > 0 && (
                <UpcomingTasksCard taskData={dashboardData.tasks} />
              )}
            </Col>
            <Col xl={4}>
              {recentActivity && recentActivity.length > 0 && (
                <RecentActivityCard
                  cardTitle="Recent activity"
                  recentActivity={recentActivity.slice(0, 3)}
                />
              )}

              {taskSummary && taskSummary.length > 0 && (
                <TaskChart cardTitle="Task completion" taskData={taskSummary} />
              )}
            </Col>
          </Row>
          {dashboardData.tasks && dashboardData.tasks.length > 0 && (
            <Row>
              <Col>
                <Calendar taskData={dashboardData.tasks} />
              </Col>
            </Row>
          )}
        </section>
        <Chat />
        {dashboardData.isLoading && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}
const mapStateToProps = (state) => ({
  recentActivity: state.activity.recentActivity,
  dashboardData: state.dashboard,
  billingData: state.billingReducer,
  userData: state.userReducer,
});
const mapDispatchToProps = () => ({
  getRecentActivity: fetchRecentActivity,
  getAllTasks: fetchTasks,
  getOnlineMembers: fetchOnlineMembers,
  getCardStatus: fetchCardStatus,
});

Dashboard.propTypes = {
  getRecentActivity: PropTypes.func,
  getAllTasks: PropTypes.func,
  recentActivity: PropTypes.array,
  dashboardData: PropTypes.object,
  getOnlineMembers: PropTypes.func,
  getCardStatus: PropTypes.func,
  billingData: PropTypes.object,
  userData: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps())(Dashboard);
